module.exports = __webpack_public_path__ + "img/tax-image.c4e1a066.jpeg";